import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PageShell from '../../components/PageShell';
import { useViewExcelExport } from '../../components/ExcelExportButton';
import { useRegisterPageExports } from '../../exports/pageExports';
import { usePersistentValue } from '../../hooks/usePersistentState';
import HrSynthesisPage from './HrSynthesisPage';

/* Détail des charges — UN écran, pas quatre onglets (2026-08-27).

   La synthèse pose l'équation en tête (rémunération + charges sociales =
   masse salariale chargée) puis les autres montants utiles ; chaque tuile est
   un bouton, et la table du dessous montre d'où vient le chiffre cliqué. Les
   onglets faisaient choisir AVANT de voir le montant ; ici on part du montant.

   L'export convertit la vue DÉJÀ rendue : l'écran n'a plus d'onglets à monter
   hors champ, et une seule table est à l'écran. */
export default function PayrollDetailHub({ activeTenant, addToast, year, onYearChange }) {
  const { t } = useTranslation();
  const tenantId = activeTenant?.id || '';
  const [unit, setUnit] = usePersistentValue(`payroll_detail_unit_${tenantId}`, 'chf');
  /* L'unité monte à la BANDE DE CONTEXTE, comme dans Finance (2026-09-18) :
     elle tenait la droite de la ligne des onglets, où elle changeait de place
     d'un onglet à l'autre. Le gabarit la place, la page la déclare. */
  const pageUnit = useMemo(() => ({ value: unit, onChange: setUnit }), [unit, setUnit]);

  const viewRef = useRef(null);
  const excel = useViewExcelExport({
    ref: viewRef,
    sheetName: 'Detail des charges',
    fileBase: 'Detail des charges',
    tenantName: activeTenant?.name,
    year,
    addToast,
  });
  useRegisterPageExports(useMemo(() => ([
    { id: 'excel', label: 'Excel', run: excel.run },
  ]), [excel.run]));

  return (
    <PageShell
      framed
      title={t('nav:items.hr-payroll-detail')}
      exportRef={viewRef}
      kind="report"
      unit={pageUnit}
    >
      <HrSynthesisPage embedded unit={unit}
                       activeTenant={activeTenant} year={year} onYearChange={onYearChange} />
    </PageShell>
  );
}
